/**
 * frappe.views.MapView
 */
frappe.provide("frappe.utils");
frappe.provide("frappe.views");

frappe.views.MapView = class MapView extends frappe.views.ListView {
	get view_name() {
		// __("Map")
		return "Map";
	}

	prepare_data(data) {
		// @dokos
		super.prepare_data(data);
		this.get_list_fields();
	}

	get_list_fields() {
		// @dokos
		this.list_fields = this.meta.fields
			.filter((f) => f.in_list_view === 1 || f.in_preview === 1)
			.reduce((prev, curr) => {
				return Object.assign(prev, { [curr.fieldname]: curr.label });
			}, {});
	}

	setup_defaults() {
		super.setup_defaults();
		this.page_title = __("{0} Map", [this.page_title]);
		this.setup_map_type();
	}

	get_fields() {
		// @dokos
		this.gelocation_fields = this.meta.fields
			.filter((f) => f.fieldtype === "Geolocation")
			.map((f) => f.fieldname);

		this.gelocation_fields.forEach((fieldname) => {
			this.fields.push([fieldname, this.doctype]);
		});
		return super.get_fields();
	}

	setup_map_type() {
		if (
			this.meta.fields.find(
				(i) => i.fieldname === "location" && i.fieldtype === "Geolocation"
			)
		) {
			this.type = "location_field";
			this._add_field("location");
		} else if (
			this.meta.fields.find((i) => i.fieldname === "latitude") &&
			this.meta.fields.find((i) => i.fieldname === "longitude")
		) {
			this.type = "coordinates";
			this._add_field("latitude");
			this._add_field("longitude");
		}
	}

	setup_view() {
		return this.load_lib().then(() => this.setup_map());
	}

	load_lib() {
		return Promise.all([
			frappe.require("leaflet.bundle.js"),
			frappe.require("leaflet.bundle.css"),
		]);
	}

	setup_map() {
		this.map_id = frappe.dom.get_unique_id();
		this.$result.html(`<div id="${this.map_id}" class="map-view-container"></div>`);

		L.Icon.Default.imagePath = frappe.utils.map_defaults.image_path;
		this.map = L.map(this.map_id).setView(
			frappe.utils.map_defaults.center,
			frappe.utils.map_defaults.zoom
		);

		this.streetLayer = L.tileLayer(
			frappe.utils.map_defaults.tiles.default_tile.url,
			frappe.utils.map_defaults.tiles.default_tile.options
		);
		this.satelliteLayer = L.tileLayer(
			frappe.utils.map_defaults.tiles.satellite_tile.url,
			frappe.utils.map_defaults.tiles.satellite_tile.options
		);
		this.labelsLayer = L.tileLayer(
			frappe.utils.map_defaults.tiles.labels_tail.url,
			frappe.utils.map_defaults.tiles.labels_tail.options
		);
		this.terrainLayer = L.tileLayer(
			frappe.utils.map_defaults.tiles.terrain_lines_tail.url,
			frappe.utils.map_defaults.tiles.terrain_lines_tail.options
		);

		this.streetLayer.addTo(this.map);

		this.bind_leaflet_layers_control();
		this.bind_leaflet_locate_control();
		L.control.scale().addTo(this.map);
		if (!this.bound_event_listeners) {
			this.bind_leaflet_event_listeners();
		}
	}

	render() {
		//const coords = this.convert_to_geojson(this.data);
		this.render_map_data();
		this.$paging_area.find(".level-left").append("<div></div>");
	}

	convert_to_geojson(data) {
		return this.type === "location_field"
			? this.get_location_data(data)
			: this.get_coordinates_data(data);
	}

	get_coordinates_data(data) {
		return data.map((row) => this.create_gps_marker(row)).filter(Boolean);
	}

	get_location_data(data) {
		return data.reduce((acc, row) => {
			const location = this.parse_location_field(row);
			if (location) {
				acc.push(...location);
			}
			return acc;
		}, []);
	}

	get_feature_properties(row) {
		// return { // @dokos
		// 	name: row.name,
		// };

		return row;
	}

	parse_location_field(row) {
		const location = JSON.parse(row["location"]);
		if (!location) {
			return;
		}

		for (const feature of location["features"]) {
			feature["properties"] = {
				...(feature["properties"] || {}),
				...this.get_feature_properties(row),
			};
		}

		return location["features"];
	}

	create_gps_marker(row) {
		// Build marker based on latitude and longitude
		if (!row.latitude || !row.longitude) {
			return;
		}

		return {
			type: "Feature",
			properties: this.get_feature_properties(row),
			geometry: {
				type: "Point",
				coordinates: [parseFloat(row.longitude), parseFloat(row.latitude)], // geojson needs it reverse!
			},
		};
	}

	// get_popup_content(feature) { // @dokos
	// 	return frappe.utils.get_form_link(this.doctype, feature.properties.name, true);

	// }

	get_popup(value, latlng) {
		let text = Object.keys(this.list_fields).reduce((prev, f) => {
			return `${prev}<p><b>${__(this.list_fields[f])}</b>: ${__(value[f] || "")}</p>`;
		}, `<div class="text-center"><strong>${frappe.utils.get_form_link(this.doctype, value.name, true)}</strong></div>`);

		if (latlng?.lat && latlng?.lng) {
			let href = "";
			let label = "";
			if (frappe.boot.is_google_maps_enabled) {
				href = `https://www.google.com/maps/search/?api=1&query=${latlng.lat},${latlng.lng}`;
				label = __("Open in Google Maps");
			} else {
				href = `https://www.openstreetmap.org/directions?from=&to=${latlng.lat}%2C${latlng.lng}#map=13/${latlng.lat}/${latlng.lng}`;
				label = __("Open in OpenStreetMap");
			}
			if (href && label) {
				text += `<div class="text-center">
					<a class="mr-4 green" href="${href}" target="_blank">
						${frappe.utils.icon("map", "sm")} ${label}
					</a>
				</div>`;
			}
		}

		return text;
	}

	get_tooltip(value) {
		return `<b>${value.name}</b>`;
	}

	render_map_data() {
		const me = this;
		me.editableLayers = new L.FeatureGroup();
		me.data.forEach((value) => {
			me.gelocation_fields.forEach((field) => {
				const geometry_value = value[field];
				const data_layers = new L.LayerGroup().addLayer(
					L.geoJson(JSON.parse(geometry_value), {
						pointToLayer: function (geoJsonPoint, latlng) {
							if (geoJsonPoint.properties.point_type == "circle") {
								return L.circle(latlng, { radius: geoJsonPoint.properties.radius })
									.bindPopup(me.get_popup(value, latlng))
									.bindTooltip(me.get_tooltip(value));
							} else if (geoJsonPoint.properties.point_type == "circlemarker") {
								return L.circleMarker(latlng, {
									radius: geoJsonPoint.properties.radius,
								})
									.bindPopup(me.get_popup(value, latlng))
									.bindTooltip(me.get_tooltip(value));
							} else {
								return L.marker(latlng)
									.bindPopup(me.get_popup(value, latlng))
									.bindTooltip(me.get_tooltip(value));
							}
						},
					})
				);
				me.add_non_group_layers(data_layers, me.editableLayers);
			});
		});
		try {
			me.map.flyToBounds(me.editableLayers.getBounds(), {
				animate: false,
				padding: [50, 50],
			});
		} catch (err) {
			// suppress error if layer has a point.
		}
		me.editableLayers.addTo(me.map);

		me.map._onResize();
	}

	add_non_group_layers(source_layer, target_group) {
		// https://gis.stackexchange.com/a/203773
		// Would benefit from https://github.com/Leaflet/Leaflet/issues/4461
		if (source_layer instanceof L.LayerGroup) {
			source_layer.eachLayer((layer) => {
				this.add_non_group_layers(layer, target_group);
			});
		} else {
			target_group.addLayer(source_layer);
		}
	}

	bind_leaflet_layers_control() {
		// Add layers control for switching between map types
		// Define base and overlay layers as properties of the class instance for access in other methods

		const baseLayers = {
			Default: this.streetLayer,
			Satellite: this.satelliteLayer,
		};
		const overlays = {
			Labels: this.labelsLayer,
			Terrain: this.terrainLayer,
		};

		L.control.layers(baseLayers, overlays).addTo(this.map);
		this.display_leaflet_overlays_control("none");
	}

	bind_leaflet_locate_control() {
		// To request location update and set location, sets current geolocation on load
		this.locate_control = L.control.locate({ position: "topright" });
		this.locate_control.addTo(this.map);
	}

	display_leaflet_overlays_control(display = "") {
		const layerControlContainer = document.querySelector(".leaflet-control-layers-overlays");
		const separator = document.querySelector(".leaflet-control-layers-separator");
		if (layerControlContainer) {
			layerControlContainer.style.display = display;
		}
		if (separator) {
			separator.style.display = display;
		}
	}

	bind_leaflet_event_listeners() {
		this.bound_event_listeners = true;
		// Remove overlays and overlays options when selecting the default view
		this.map.on("baselayerchange", (e) => {
			if (e.name === "Satellite") {
				// Show overlays options and separator only in Satellite view
				this.display_leaflet_overlays_control();
			} else {
				// Hide overlays options and separator in other views
				this.display_leaflet_overlays_control("none");
				// Remove all overlays
				Object.values(this.map._layers).forEach((layer) => {
					if (
						layer instanceof L.TileLayer &&
						(layer._url === frappe.utils.map_defaults.tiles.labels_tail.url ||
							layer._url === frappe.utils.map_defaults.tiles.terrain_lines_tail.url)
					) {
						this.map.removeLayer(layer);
					}
				});
			}
		});
	}
};
